<template>
  <dl class="invoice">
    <dt class="title">发票信息</dt>
    <dd class="item">
      <label class="name">抬头类型：</label>
      <span class="text">{{invoice.titleType || '空'}}</span>
    </dd>
    <dd class="item">
      <label class="name">发票抬头：</label>
      <span class="text">{{invoice.title || '空'}}</span>
    </dd>
    <dd class="item">
      <label class="name">纳税识别号：</label>
      <span class="text">{{invoice.taxpayerNo || '空'}}</span>
    </dd>
    <dd class="item">
      <label class="name">注册电话：</label>
      <span class="text">{{invoice.registeredPhone || '空'}}</span>
    </dd>
    <dd class="item">
      <label class="name">开票地址：</label>
      <span class="text">{{invoice.invoiceAddress || '空'}}</span>
    </dd>
    <dd class="item">
      <label class="name">开户行：</label>
      <span class="text">{{invoice.bank || '空'}}</span>
    </dd>
    <dd class="item">
      <label class="name">开户账号：</label>
      <span class="text">{{invoice.account || '空'}}</span>
    </dd>
  </dl>
</template>

<script>
import * as api from 'src/api'
export default {

  props: {
    id: {
      required: true
    }
  },

  data () {
    return {
      invoice: ''
    }
  },
  mounted () {
    let url = '/invoice/getCustomerInvoiceDetail.html'
    api.post(url, {invoiceId: this.id}, (data) => {
      this.invoice = data.result
    })
  }
}
</script>

<style lang="less" scoped>
  @import '../../../assets/less/variable.less';
  // 发票详情
  .invoice {
    .title {
      height: 24px;
      line-height: 24px;
      border-left: 4px solid @light-blue;
      color: @light-blue;
      padding-left: 12px;
      font-size: 15px;
    }
    .red-title {
      color: @bg-red;
      border-left: 4px solid @bg-red;
    }
    .item {
      line-height: 1.5;
      margin-top: 10px;
      font-size: 13px;
      position: relative;
      padding-left: 110px;
      min-height: 19px;
      .name {
        color: @light-gray;
        display: inline-block;
        width: 90px;
        position: absolute;
        left: 15px;
        top: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .text-red {
        color: @bg-red;
      }
      .img-box {
        display: inline-block;
        vertical-align: top;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// customer-invoice.vue?de9deee0